module.exports = __webpack_public_path__ + "media/images/mailer/icon_done-e07ea253e82d137816cfb8d77a3b1562.png";